import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalWrapper = _ref => {
  let {
    children,
    condition,
    WrapperComponent,
    wrapperProps
  } = _ref;
  return condition ? /*#__PURE__*/_jsx(WrapperComponent, {
    ...wrapperProps,
    children: children
  }) : children;
};
ConditionalWrapper.propTypes = {
  children: PropTypes.node,
  condition: PropTypes.bool,
  WrapperComponent: PropTypes.elementType,
  wrapperProps: PropTypes.object
};
export default ConditionalWrapper;